import * as React from 'react';
import classNames from 'classnames';
import { Button } from '@msdyn365-commerce-modules/utilities';

export interface IMilSelectedRefinersProps {
    selectedRefiners: Record<string, string[]>;
    onRemove?: (facetName: string, value: string) => void;
    onClearAll?: () => void;
    className?: string;
}

const MilSelectedRefiners: React.FC<IMilSelectedRefinersProps> = ({ selectedRefiners, onRemove, onClearAll, className }) => {
    if (!selectedRefiners || Object.keys(selectedRefiners).length === 0) {
        return null;
    }

    const items: { facet: string; value: string }[] = [];
    Object.keys(selectedRefiners).forEach(facet => {
        const values = selectedRefiners[facet] || [];
        for (const v of values) {
            if (v !== undefined && v !== null && String(v).trim() !== '') {
                items.push({ facet, value: String(v) });
            }
        }
    });

    if (items.length === 0) {
        return null;
    }

    const handleRemove = (facet: string, value: string) => {
        if (onRemove) {
            onRemove(facet, value);
        } else {
            console.warn('MilSelectedRefiners: onRemove not provided', facet, value);
        }
    };

    const handleClearAll = () => {
        if (onClearAll) {
            onClearAll();
        }
    };

    return (
        <div className={classNames('mil-selected-refiners', className)}>
            <ul className='mil-selected-refiners__list'>
                {items.map((it, idx) => (
                    <li className='mil-selected-refiners__item' key={`${it.facet}::${it.value}::${idx}`}>
                        <span className='mil-selected-refiners__label' title={`${it.facet}: ${it.value}`}>
                            {it.value}
                        </span>
                        <Button
                            className='mil-selected-refiners__remove msc-btn--icon'
                            aria-label={`Remove filter ${it.value}`}
                            onClick={() => handleRemove(it.facet, it.value)}
                        ></Button>
                    </li>
                ))}
            </ul>

            <div className='mil-selected-refiners__clear'>
                <button className='mil-selected-refiners__clear-btn' onClick={handleClearAll}>
                    Clear all
                </button>
            </div>
        </div>
    );
};

export default MilSelectedRefiners;
